import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { LOGIN_ROUTE } from "../../config/RoutesConstants"
import {
  Field,
  reduxForm,
  formValueSelector,
  change,
  getFormValues
} from "redux-form";
import { TextField, Select } from "redux-form-material-ui";
import { required } from "../../common/Validations";
import { 
  Container, 
  Box, 
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  IconButton,
  InputLabel,
  Fab,
  Grid,
  Paper,
  Typography, 
  Tooltip,
  Input,
  Icon,
  Toolbar,
  MenuItem,  
} from "@material-ui/core"
import SelectMaterial from "@material-ui/core/Select"
import { Autocomplete } from"@material-ui/lab"
import AddIcon from "@material-ui/icons/Add"
import GoogleMapLocation from "../../components/GoogleMapLocation"
import { withTheme } from "@material-ui/core/styles"
import BackIcon from '@material-ui/icons/ArrowBackRounded';
import Util, { ERROR, SUCCESS, handleSubmitFail } from '../../common/Util'
import ImageSelector from '../../components/ImageSelector/ImageSelector'
import { actionSaveNotification } from '../../actions/NotificationActions'
import moment from 'moment'
let _handleSubmitFail;
class AddEditNotifications extends React.PureComponent{
  constructor(props){
    super(props)
    this.state={imgEdit:null, imgNameEdit:null}
    this.onClean=this.onClean.bind(this)
    this.onSave=this.onSave.bind(this)
    _handleSubmitFail=this.handleSubmitFail.bind(this)
  }

  componentWillMount(){
    if(!this.props.login){
      this.props.history.replace(LOGIN_ROUTE);
    }
    
    if(this.props.isEditing){
      let notification=this.props.history.location.state//this.props.notification
      console.log("NOTIFICATION", notification)
      if(notification){  
        notification.tskRunDate = notification.tskRunDate&&Util.timestampToMoment(notification.tskRunDate).format('YYYY-MM-DDTHH:mm')
        this.props.initialize(notification)
        notification.tskParams&&this.setState({imgEdit:notification.tskParams.image, imgNameEdit:notification.tskParams.nameImg})
      }else{
        this.props.history.replace(LOGIN_ROUTE);
      }
    }else{
      this.props.initialize({tskStatus:"scheduled", tskTask:"notify"})
    }
  }
  
  handleSubmitFail(error){
    console.log("ERROR EN EL SUBMIT", error)
  }

  onClean(){
    let initNoti = {tskStatus:"scheduled", tskTask:"notify"}
    if(this.props.isEditing){
      let notification=this.props.notification
      if(notification.tskParams&&notification.tskParams.pathImg){
        initNoti.tskParams = {pathImg:notification.tskParams.pathImg}
      }
      this.props.initialize(initNoti)
    }else{
      this.props.initialize(initNoti)
    }
    this.setState({imgEdit:null, imgNameEdit:null})
  }

  onSave(formValues){
    this.props.actionSaveNotification(formValues
      , ()=>{Util.showNoty(SUCCESS, "La notificación se guardó correctamente."); this.props.history.goBack()}
      , (e)=>{
        console.log("ERROR ON SAVE NOTIFICATION", e)
        if(!(e&&e.status&&e.status==401))
          Util.showNoty(ERROR, "No se pudo guardar la notificación.")
      }
    )
  }

  render(){
    const { theme, handleSubmit, isEditing } = this.props
    const title = isEditing?"Editar Notificación":"Crear Notificación"
    return (
      <Box style={theme.mainContainer}>
        <Box style={{...theme.title.container, flexDirection:"row", display:"flex"}}>
          <Box style={theme.title.backIconContainer}>
            <IconButton onClick={this.props.history.goBack} style={theme.title.backIcon}>
              <BackIcon style={{fontSize:"2.5rem"}} stroke="white" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round"/>
            </IconButton>
          </Box>
          <Box>
            <Typography variant="h1">Crear Notificaciones</Typography>
            <Typography variant="subtitle1">Crea Notificaciones</Typography>
          </Box>
        </Box>
        <Container>        
          <Paper >
            <Typography style={theme.paper.title} variant="h2">{title}</Typography>
            <form style={theme.paper.form}>
              <Grid container xs={12} spacing={3} direction="row">
                <Grid item xs={6}>
                  <Field
                    component={TextField}
                    name="tskParams.title"
                    label="Título de la notificación"
                    fullWidth
                    validate={[required]}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Field
                    component={TextField}
                    name="tskRunDate"
                    label="Fecha a notificar"
                    type="datetime-local"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    validate={[required]}
                  />
                  </Grid>
              </Grid>
              <Grid container direction="row" spacing={3}>
                <Grid item xs={4}>
                  <ImageSelector
                    fieldName="tskParams.image"
                    // validate={[required]}
                    fileDimentions={{ width: 750, height: 370 }}
                    styleButton={theme.imageSelector}
                    imagePreviewUrl={this.state.imgEdit}
                    fileName={this.state.imgNameEdit}
                    fileSize={300000}
                    showDelete={true}
                    noPreview
                  />
                </Grid>
                  <Grid item xs={8}>
                    <Field
                      component={TextField}
                      name="tskParams.body"
                      label="Cuerpo de la notificación"
                      fullWidth
                      multiline
                      rows={4}
                      validate={[required]}
                    />
                </Grid>
              </Grid>
            </form>
          </Paper>
          <Toolbar style={theme.footer.toolbar}>
            <Tooltip title="Limpiar">
              <Button variant="contained" color="secondary" style={theme.footer.button} onClick={this.onClean}>Limpiar</Button>
            </Tooltip>
            <Tooltip title="Cancelar">
              <Button variant="contained" color="secondary" style={theme.footer.button} onClick={this.props.history.goBack}>Cancelar</Button>
            </Tooltip>
            <Tooltip title="Guardar">
              <Button variant="contained" color="primary" style={theme.footer.button} onClick={handleSubmit(this.onSave)}>Guardar</Button>
            </Tooltip>
          </Toolbar>
        </Container>
      </Box>
    )
  }
}
function mapStateToProps(store) {
  // console.log("STORE RESTAURANT", store)
  return {
    login: store.auth.login,
    notification: store.ntf.notification
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionSaveNotification,
    },
    dispatch
  );
}

export default  reduxForm({
  form: "addEditNotifications",
  onSubmitFail: errors => _handleSubmitFail(errors)
})(withRouter(
    withTheme(
      connect(
        mapStateToProps,
        mapDispatchToProps
      )(AddEditNotifications)
    )
  )
)


// WEBPACK FOOTER //
// ./src/screens/notifications/AddEditNotifications.js